import type {
  AlertOutput,
  CreateAlert,
} from "@/commons/types/api/schema.types";
import { httpRequest } from "../utils/request.utils";
import { handleNetworkError } from "../utils/handleNetworkError";

export const createAlert = async (payload: CreateAlert) => {
  try {
    const response = await httpRequest<AlertOutput, CreateAlert>(
      "post",
      "/alerts",
      payload
    );

    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};
